import * as React from "react";
import { withRouter } from 'react-router'
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";


class MiniSpinner extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { className } = this.props;
        return (
            <div className={className ? className : "spinner"} style={this.props.style}>
                <div className="bounce1" />
                <div className="bounce2" />
                <div className="bounce3" />
            </div>
            );
    }
}

export default MiniSpinner;


